<template>
    <div>
        <nav
            id="navigation"
            class="flex fixed w-full items-center sm:justify-center px-6 h-16 text-gray-800 border-b border-green-600 z-10">
            <div class="logo">
                <inertia-link :href="route('terminal.lobby')" class="hidden md:block">
                    <img alt="Platform Light" class="h-auto w-40 mx-auto" src="/assets/logo.png"/>
                </inertia-link>
            </div>
            <div>
                <h2 class="text-xl sm:text-2xl mx-auto">
                    <portal-target name="title" />
                </h2>
            </div>
            <div></div>
            <div class="balance flex">
                <div class="flex items-center px-2 py-1 font-xl ml-2 text-sm md:text-md">
                    <font-awesome-icon class="mr-2" icon="user"/> {{$page.props.user.username}}
                </div>
                <div class="flex items-center px-2 py-1 font-xl ml-2 text-sm md:text-md">
                    <font-awesome-icon class="mr-2" icon="mobile-alt"/> {{$page.props.user.terminal_id.substring(0,15)}} ...
                </div>
                <balance :balance="$page.props.balance"></balance>
                <a v-if="showWithdrawalButton" @click="openWithdrawalModal" class="cursor-pointer justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:text-sm">
                    {{$t('Withdrawal')}}
                </a>
            </div>
        </nav>
        <flash-messages />
        <main id="terminal" class="mx-auto">
            <slot />
        </main>
        <InfoScreen></InfoScreen>
    </div>
</template>

<script>
import FlashMessages from '@/Shared/Components/FlashMessages';
import Balance from "./Components/Balance";
export default {
    name: "TerminalLayout",
    components: { Balance, FlashMessages },
    props: {
        showWithdrawalButton: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            currentLanguageIndex: 0,
        };
    },
    methods: {
        listenOnKeydown(e) {
            if (e.key === 'l') {
                this.switchLanguage();
            }
        },
        openWithdrawalModal() {
            this.$emit('openWithdrawalModal')
        },
        switchLanguage() {
            this.currentLanguageIndex = (this.currentLanguageIndex + 1) % window.languages.length;
            const newLanguage = window.languages[this.currentLanguageIndex];

            this.$i18n.locale = newLanguage;
            this.$inertia.post(route('user.setLanguage').url(), { language: newLanguage }, { preserveScroll: true });
        }
    },
    created() {
        window.addEventListener('keydown', this.listenOnKeydown);

        if (this.$page.props.user.language !== this.$i18n.locale) {
            this.$i18n.locale = this.$page.props.user.language;
        }

        Echo
            .private(`player-${this.$page.props.user.id}`)
            .listen('ReloadPlayer', () => {
                console.log('reload');
                window.location.reload();
            });
    },
    beforeDestroy() {
        window.removeEventListener('keydown', this.listenOnKeydown);
    }
}
</script>

<style lang="scss" scoped>
#terminal {
    padding-top: 64px;
}

.logo {
    position: absolute;
    left: 1rem;
}

.balance {
    position: absolute;
    right: 1rem;
}

nav {
    background-color: #fff;
}
</style>
